module.exports = __webpack_public_path__ + "images/feature/recycle-1-4bed651d41795b5ddb1fc7779acfe367.png";